import Vue from 'vue'
import template from './index.pug'
import Frame2713 from 'assets/images/info-bono/Group 2713.svg'
import Frame2706 from 'assets/images/info-bono/Group 2706.svg'
import LogoGE from 'assets/images/logo.svg'
import LogoGC from 'assets/images/logo_prod_GC.png'
export default Vue.extend({
  template: template(), 
  
  components: {
  },

  computed: {
  },

  data() {
    return {
      frame2713:Frame2713,
      frame2706:Frame2706,
      logoGe:LogoGE,
      logoGc:LogoGC
    }
  },

  methods: {
  }
})